// extracted by mini-css-extract-plugin
export default {"navBarContainer":"DashboardBottomNavBar_navBarContainer__-drzx"};